import React, { useEffect, useState } from 'react'
import {
  faDroplet,
  faFlaskVial,
  faFolder,
  faIndustry,
  faLeaf,
  faTag,
} from '@fortawesome/free-solid-svg-icons'
import { ItensPerUserLogged } from '../../../../../../../../services/login/permissaoUsuarioLoado'
import Input from '../../../../../../../../Components/CustomUi/input'
import { Select } from '../../../../../../../../Components/CustomUi/Select'
import TextArea from '../../../../../../../../Components/CustomUi/textarea'
interface PropsFormDadosInsumo {
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  classeAgro: string
  setClasseAgro: React.Dispatch<React.SetStateAction<string>>
  fabricante: string
  setFabricante: React.Dispatch<React.SetStateAction<string>>
  setFabricanteId: React.Dispatch<React.SetStateAction<number>>

  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>
  dataCatProduto: any[]
  dataCatCategoria: any[]
  dataFabricantes: any[]
  handleChangeClasse: Function
}

export const FormDadosInsumo: React.FC<PropsFormDadosInsumo> = ({
  nome,
  setNome,
  classeAgro,
  setClasseAgro,
  fabricante,
  setFabricante,
  setFabricanteId,
  observacao,
  setObservacao,
  dataCatProduto,
  dataFabricantes,
  handleChangeClasse,
}) => {
  const [openClasse, setOpenClasse] = useState(false)
  const [openFabricante, setOpenFabricante] = useState(false)

  return (
    <>
      <Input
        label='Nome'
        placeholder='Digite o nome do adjuvante'
        value={nome}
        onChange={setNome}
        icon={faTag}
      />
      <div className='campo__dois__inputs'>
        {/* <Select
          label='Tipo de adjuvante'
          placeholder='Selecione o tipo de adjuvante'
          icon={faFolder}
          value={categoria_insumo}
          onChange={setCategoria_insumo}
          onChangeID={setCategoria_insumoId}
          open={openCategoriaInsumo}
          trigger={setOpenCategoriaInsumo}
          items={dataCatProduto}
          descricaoItem={'nome'}
          idItem={'cod'}
        /> */}

        <Select
          label='Categoria'
          placeholder='Selecione a categoria'
          icon={faLeaf}
          value={classeAgro}
          onChange={setClasseAgro}
          onChangeID={(e) => handleChangeClasse(e)}
          open={openClasse}
          trigger={setOpenClasse}
          items={dataCatProduto}
          descricaoItem={'nome'}
          idItem={'cod'}
        />
      </div>
      <Select
        label='Fabricante'
        placeholder='Selecione o fabricante'
        value={fabricante}
        icon={faIndustry}
        onChange={setFabricante}
        onChangeID={setFabricanteId}
        open={openFabricante}
        trigger={setOpenFabricante}
        items={dataFabricantes}
        descricaoItem={'nome'}
        idItem={'cod'}
      />
     
      <TextArea label='Observação' placeholder={''} value={observacao} onChange={setObservacao} />
    </>
  )
}